import React from 'react';
import { Monitor, Server, Shield, Terminal } from 'lucide-react';

const iconMap = {
  Monitor,
  Server,
  Shield,
  Terminal
};

const colorClasses = {
  cyan: 'bg-cyan-500/10 border-cyan-500/20 text-cyan-400',
  amber: 'bg-amber-500/10 border-amber-500/20 text-amber-400',
  green: 'bg-green-500/10 border-green-500/20 text-green-400',
  neutral: 'bg-neutral-500/10 border-neutral-500/20 text-neutral-400'
};

const SkillCard = ({ skill }) => {
  const Icon = iconMap[skill.icon];
  const colorClass = colorClasses[skill.color];

  return (
    <div className="group bg-neutral-900/50 border border-neutral-800 rounded-lg p-6 hover:border-neutral-700 transition-all hover:translate-y-[-4px]">
      <div className={`inline-flex items-center justify-center w-12 h-12 rounded-lg border ${colorClass} mb-4`}>
        <Icon size={24} />
      </div>
      <h3 className="text-lg font-semibold text-white mb-3">{skill.category}</h3>
      <div className="space-y-2">
        {skill.items.map((item, index) => (
          <div key={index} className="flex items-center justify-between text-sm">
            <span className="text-neutral-300">{item.name}</span>
            <div className="flex items-center gap-2">
              <div className="w-20 h-1.5 bg-neutral-800 rounded-full overflow-hidden">
                <div
                  className={`h-full rounded-full ${
                    skill.color === 'cyan' ? 'bg-cyan-400' :
                    skill.color === 'amber' ? 'bg-amber-400' :
                    skill.color === 'green' ? 'bg-green-400' :
                    'bg-neutral-400'
                  }`}
                  style={{ width: `${item.level}%` }}
                />
              </div>
              <span className="text-neutral-500 text-xs w-8 text-right">{item.level}%</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkillCard;
